import React from "react";
import Image from "next/image";
import dynamic from "next/dynamic";
const CardDots = dynamic(() => import("@/Components/DataDisplayCompoants/CardDots"),{ssr: true});
import { parseHtml } from "@/utils/common";

interface CardProps {
  desc: string;
}
const Card: React.FC<CardProps> = ({ desc }) => {
  // Hardcoded static data
  const backgroundImage = "/images/career-blue-shape-b.png";

  return (
    <div className=" relative group  h-full">
      <div className=" absolute top-0 right-0 w-full h-full">
        <Image
          src={backgroundImage}
          alt="industry bg"
          width={810}
          height={393}
          quality={100}
          className="w-full  h-full max-h-full object-cover object-center"
        />
      </div>
      <CardDots />

      <div className="relative z-10 flex items-center right-0 justify-center left-0 py-[26px] px-[26px] xl:px-[50px] h-full">
        <p className="text-subtitle-2 mx-auto font-semibold text-primary-text mt-2">
          {parseHtml(desc ?? "")}
        </p>
      </div>
    </div>
  );
};
export default Card;
